
(function () {
  const maxVisible = 6; // show first 5 swatches, replace 6th with +X

  function updateSwatches(container) {
    const swatches = container.querySelectorAll(".swatch");
    if (!swatches.length) return;

    // Prevent duplicate +X
    if (container.querySelector(".more-swatch")) return;

    if (swatches.length > maxVisible) {
      // Hide after the 5th
      for (let i = maxVisible; i < swatches.length; i++) {
        swatches[i].style.display = "none";
      }

      // Calculate remaining
      const extraCount = swatches.length - maxVisible;

      // Create dynamic +X
      const moreIndicator = document.createElement("span");
      moreIndicator.className = "swatch more-swatch";
      moreIndicator.textContent = `+${extraCount}`;

      // Insert at the 6th position
      container.insertBefore(moreIndicator, swatches[maxVisible]);
    }
  }

  // Use MutationObserver so it works inside sliders/lazy load
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.matches(".card__swatches")) {
            updateSwatches(node);
          }
          node.querySelectorAll?.(".card__swatches").forEach((c) =>
            updateSwatches(c)
          );
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Initial run on existing products
  document.querySelectorAll(".card__swatches").forEach((c) =>
    updateSwatches(c)
  );
})();
